const YOUTUBE_ID_REGEX = /^[A-Za-z0-9_-]{11}$/;

const YOUTUBE_HOST_REGEX = /^(?:www\.|m\.)?(?:youtube(?:-nocookie)?\.com|youtu\.be)$/i;

export function parseYoutubeId(url: string | null | undefined): string | null {
  if (!url) return null;
  const trimmed = url.trim();
  if (!trimmed) return null;

  if (YOUTUBE_ID_REGEX.test(trimmed)) return trimmed;

  let parsed: URL;
  try {
    parsed = new URL(trimmed);
  } catch {
    return null;
  }

  if (!YOUTUBE_HOST_REGEX.test(parsed.hostname)) return null;

  const host = parsed.hostname.replace(/^(?:www\.|m\.)/i, '').toLowerCase();

  let candidate: string | null = null;

  if (host === 'youtu.be') {
    candidate = parsed.pathname.split('/').filter(Boolean)[0] ?? null;
  } else {
    const queryId = parsed.searchParams.get('v');
    if (queryId) {
      candidate = queryId;
    } else {
      const segments = parsed.pathname.split('/').filter(Boolean);
      const prefixIndex = segments.findIndex(
        (segment) => segment === 'live' || segment === 'embed' || segment === 'shorts',
      );
      if (prefixIndex !== -1) {
        candidate = segments[prefixIndex + 1] ?? null;
      }
    }
  }

  if (candidate && YOUTUBE_ID_REGEX.test(candidate)) return candidate;
  return null;
}

export function isYoutubeUrl(url: string | null | undefined): boolean {
  return parseYoutubeId(url) !== null;
}
